<template>
  <!-- サニタイズ済みなのでeslintの警告を無視 -->
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div :class="props.class" v-html="sanitizedHtml"></div>
</template>

<script setup lang="ts">
import { defineProps, computed } from 'vue';
import DOMPurify from 'dompurify';

const props = defineProps({
  html: {
    type: String,
    required: true,
  },
  class: {
    type: String,
    default: '',
  },
});

// HTMLをサニタイズするcomputed
const sanitizedHtml = computed(() => {
  return DOMPurify.sanitize(props.html);
});
</script>
